// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_o3k","cls2":"PaperClaiming-cls2_qb1 PaperClaiming-cls1_o3k"};